import { DeepPartial, AppConfig, Menu } from "../../../../src/app/interfaces/app-config";

export const projectConfig: DeepPartial<AppConfig> = {
    mobileMenu: [
        Menu.create({
            id: 1,
            path: '/home',
            title: 'Comprar',
            icon: '/assets/icons/home_white.svg',
            iconType: 'img'
        }),
        Menu.create({
            id: 3,
            path: '/tickets-saved',
            title: 'Mis Compras',
            icon: '/assets/icons/ticket_white.svg',
            iconType: 'img'
        }),
    ],
    footerMenu: [
        {
            id: 3,
            title: 'Atención al cliente',
            menu: [
                Menu.create({
                    id: 8,
                    path: 'https://api.whatsapp.com/send?phone=59169777799',
                    title: '69777799',
                    external: true,
                    target: '_blank',
                    icon: 'assets/icons/whatsapp_white.svg',
                    iconType: 'img'
                }),
            ]
        },
        {
            id: 2,
            // title: 'Redes sociales',
            menu: [
                Menu.create({
                    id: 8,
                    path: 'https://www.facebook.com/fexcobo/?locale=es_LA',
                    // title: 'Facebook',
                    external: true,
                    target: '_blank',
                    icon: 'assets/icons/facebook.svg',
                    iconType: 'img'
                }),
                Menu.create({
                    id: 8,
                    path: 'https://www.instagram.com/fexco_bo?fbclid=IwY2xjawI7z7VleHRuA2FlbQIxMAABHc3Q1TmGCvM-s1SU-uRyalD96ah5Pgrhkl2iB7u_gabbJN1r3IbcCqvfuw_aem_JnXDFfjLkkF9oZNGBq0AUA',
                    // title: 'Instagram',
                    external: true,
                    target: '_blank',
                    icon: 'assets/icons/instagram.svg',
                    iconType: 'img'
                }),
                // Menu.create({
                //     id: 9,
                //     path: 'https://www.youtube.com/',
                //     // title: 'YouTube',
                //     external: true,
                //     target: '_blank',
                //     icon: 'assets/icons/youtube.svg',
                //     iconType: 'img'
                // }),
                Menu.create({
                    id: 10,
                    path: 'https://www.tiktok.com/@fexcobolivia?fbclid=IwY2xjawI7z7dleHRuA2FlbQIxMAABHbf5Fudt1IdE3j1_7JNLI2kDoB_Ado_qrcQnyuzCV4XbH2Z_83Aaup468w_aem_OFyMDAvHaYpH81zNacwXCw',
                    // title: 'TikTok',
                    external: true,
                    target: '_blank',
                    icon: 'assets/icons/tiktok.svg',
                    iconType: 'img'
                }),
            ]
        },
    ],
    pages: {
        login: {
            title: 'Login',
        }
    },
    swiperBanner: [
        {
            desktop: 'assets/img/general/banners/banner-web.jpg',
            mobile: 'assets/img/general/banners/banner-mobile.jpg'
        },
        // {
        //     desktop: 'assets/img/general/1banner.jpg',
        //     mobile: 'assets/img/general/BannerEvento400x400.jpg'
        // }
    ],
    swiperBannerSuccess: [
        {
            desktop: 'assets/img/general/banners/banner-web.jpg',
            mobile: 'assets/img/general/banners/banner-mobile.jpg'
        }
    ],
    authGoogle: true,
    underConstruction: null,
    // underConstruction: {
    //     countdown: {
    //         // date: new Date(2025, 2, 12), // 12 de Marzo, 2025,
    //         // date: new Date('2025-03-12T10:00:00'), // 24 de Abril, 2025,
    //         date: new Date('2025-03-12T09:40:00'), // 24 de Abril, 2025,
    //         label: 'Venta de entradas disponibles en...',
    //         labelFinished: '¡Ahora!',
    //     },
    //     title: null,
    //     description: null,
    //     image: 'assets/img/general/banners/banner.png'
    // },
    authGuest: true,
    hasSearch: false,
    hasServiceFee: false,
    hasFooterResponsive: true,
    terms: `<p class="mb-3 text-center"><strong>TERMINOS Y CONDICIONES</strong></p><p class="mb-10 text-justify">El adquiriente de la presente entrada se hace total responsable por la información y claves de acceso que contenga dicha entrada, ya que dicha información será entregada y/o enviada únicamente al adquiriente de dicha entrada. Al ser una entrada digital, la misma puede ser utilizada para ingresar al evento en formato físico impreso o en formato digital mediante un dispositivo electrónico, por lo que la persona que presente dichas claves de acceso en el ingreso al evento podrá ingresar siempre y cuando la misma no haya ingresado previamente al mismo. En caso de que dichas claves de acceso caiga en manos de terceros el único responsable será el adquiriente de la entrada.<br>La ejecución en la fecha, día y hora del evento para el cual es válida la presente entrada es de plena y única responsabilidad de la empresa productora del evento y en ningún caso de Todotix SRL. Los datos de la empresa o persona responsable del evento para cual la presente entrada es válida serán impresas en la parte anterior de esta entrada. Todotix SRL se libra de cualquier daño, lesión y/o muerte causada directa o indirectamente por la participación o asistencia al evento para la cual la presente entrada es válida. No se aceptan cambios. No se aceptan devoluciones. No se otorgan reembolsos. Entradas perdidas no serán reemplazadas ni reembolsadas. La devolución de dinero por la cancelación o no realización del evento será responsabilidad del organizador de eventos. Condiciones y términos sujetos escribir a legal@todotix.com. No será permitido el ingreso al evento con pirotecnia, grabadores, filmadoras, cámaras de fotografía y de video, ni cualquier elemento similar a los mencionados a criterio del Organizador, pudiendo los mismos ser retirados del lugar y destruido su contenido. El Organizador podrá solicitar que se apague todo equipo de radio llamada o teléfono celular antes del acceso al evento. El adquiriente de la presente entrada es responsable de revisar, aceptar y confirmar los términos y condiciones de su compra previo a realizarla. La edad mínima para la cual un niño o niña debe pagar la entrada será determinado por el organizador del evento. Todas las ventas son finales.</p>`
};

import { Injector } from "@angular/core";
import { EncryptionService } from "../../../../src/app/services/encryption.service";
import { environment } from "../environments/environment";

const injector = Injector.create({ providers: [{ provide: EncryptionService, useClass: EncryptionService, deps: [] }] });
const encryptionService = injector.get(EncryptionService);

export function projectEncryptData(data: any) {
    const encryptedConfig = encryptionService.encrypt(data, environment.keyEncript, environment.ivEncript);
    return encryptedConfig;
}
